'use strict';

var _ = require('lodash');
var DemandAdjustmentChartDirective = function DemandAdjustmentChartDirective($timeout, angularHelper, Chart, TotalChart, dataProviderService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-adjustment-chart.html'),
    controller: 'DemandAdjustmentChartController',
    scope: {
      chartId: '=',
      current: '=',
      shareData: '=',
      compareMode: '=',
      onResetHandler: '&',
      isChartDraggable: '=',
      isUserInputDisabled: '='
    },
    link: function link(scope, element) {
      scope.separatedChart = new Chart(element.find('.separated'), scope.chartFormatters);
      scope.totalChart = new TotalChart(element.find('.total'), scope.chartFormatters);
      function isCurrentChartAndDataPresent() {
        return scope.current.chart !== null && scope.current.chart === scope.chartId && scope.shareData !== undefined;
      }
      function render() {
        scope.separatedChart.withDraggable(scope.isChartDraggable);
        if (isCurrentChartAndDataPresent()) {
          var data = dataProviderService.transformData(scope.shareData, scope.compareMode);
          scope.separatedChart.render(data.separated, scope.isWideBarMode());
          scope.totalChart.render(data.total);
          $timeout(function () {
            scope.$broadcast('perfect-scrollbar:update');
          }, 0);
        }
      }
      scope.$watch('compareMode', render);
      scope.$watch('shareData', render, true);
      scope.$watch('current.chart', function () {
        $timeout(render, 0);
      });
      scope.separatedChart.on('bardragged', function (value, share) {
        _.find(scope.shareData.user, ['groupId', value]).value = share;
        angularHelper.triggerApply(scope);
      });
    }
  };
};
DemandAdjustmentChartDirective.$inject = ['$timeout', 'AngularHelper', 'MarketAnalysisDemandAdjustmentChart', 'MarketAnalysisDemandAdjustmentTotalChart', 'MarketAnalysisDemandAdjustmentDataService'];
module.exports = DemandAdjustmentChartDirective;